import { useState } from "react";

// Imports de Navbar y contexto si los tienes
import { NavBarAdm } from "../Components/NavBarAdm";

//Import Hooks
import { useDataContext } from "../Context/dataContext";
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useFetchDataUsers } from "../Hooks/useFetchDataUsers";
import { useFetchAllMovements } from "../Hooks/useFetchAllMovements";
import { useFetchReferralMovements } from "../Hooks/useFetchReferralMovements";
import { useFetchPointRedemptions } from "../Hooks/useFetchPointRedemptions";

// Import Flags
import venezuelaFlag from "../Assets/Images/venezuela.png";

// Import DatePickercss
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// Dentro del componente Relation, junto a otros useState


// Relación
function Relation() {
  // Context and hooks
  useAxiosInterceptors();
  const { accessToken } = useDataContext();
  const { movements } = useFetchAllMovements(accessToken.access_token);
  const { users } = useFetchDataUsers(accessToken.access_token);
  const { redemptions, loadingRedemptions, errorRedemptions } = useFetchPointRedemptions(
  accessToken.access_token
);

  const [fechaFiltroReferrals, setFechaFiltroReferrals] = useState("");

  
  // Usuarios ficticios
  const flagMap = {
    Venezuela: venezuelaFlag,
  };
  
  // Filtros
  const [tipoMovimiento, setTipoMovimiento] = useState("TODOS");
  const [filtro, setFiltro] = useState("TODOS");
  const [fechaFiltro, setFechaFiltro] = useState(new Date().toISOString().split("T")[0]);


  const [filterDate, setFilterDate] = useState(new Date());
  const [showAll, setShowAll] = useState(true);

  // Filtrar por fecha
 const filteredRedemptions = showAll
  ? redemptions
  : redemptions.filter((r) => {
      if (!filterDate) return true; // si no hay fecha, mostrar todo
      return r.pr_date.slice(0, 10) === filterDate.toISOString().slice(0, 10);
    });


  // Estados para los modales
  const [showModal, setShowModal] = useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);
  const [showModalDepositsAndWithdrawals, setShowModalDepositsAndWithdrawals] =
    useState(false);

  const [dailyDate, setDailyDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  // Filtrar usuarios con saldo positivo
  const usersWithPositiveBalance = users.filter(
    (user) =>
      user.use_amountUsd > 0 || user.use_amountEur > 0 || user.use_amountGbp > 0
  );

const { referralMovements, loading: loadingReferrals, error: errorReferrals } =
  useFetchReferralMovements(accessToken.access_token);

  // Ranking de depósitos
  const getUserDepositRanking = () => {
    return users
      .map((user) => {
        const totalDepositsEur = movements
          .filter(
            (mov) =>
              mov.User.use_id === user.use_id &&
              mov.mov_type === "Deposito" &&
              mov.mov_status === "V" &&
              mov.mov_currency === "EUR" &&
              (!startDate || new Date(mov.mov_date) >= startDate) &&
              (!endDate || new Date(mov.mov_date) <= endDate)
          )
          .reduce((sum, mov) => sum + mov.mov_amount, 0);

        const totalDepositsUsd = movements
          .filter(
            (mov) =>
              mov.User.use_id === user.use_id &&
              mov.mov_type === "Deposito" &&
              mov.mov_status === "V" &&
              mov.mov_currency === "USD" &&
              (!startDate || new Date(mov.mov_date) >= startDate) &&
              (!endDate || new Date(mov.mov_date) <= endDate)
          )
          .reduce((sum, mov) => sum + mov.mov_amount, 0);

        const totalDepositsGbp = movements
          .filter(
            (mov) =>
              mov.User.use_id === user.use_id &&
              mov.mov_type === "Deposito" &&
              mov.mov_status === "V" &&
              mov.mov_currency === "GBP" &&
              (!startDate || new Date(mov.mov_date) >= startDate) &&
              (!endDate || new Date(mov.mov_date) <= endDate)
          )
          .reduce((sum, mov) => sum + mov.mov_amount, 0);

        return {
          ...user,
          totalDepositsEur,
          totalDepositsUsd,
          totalDepositsGbp,
        };
      })
      .filter(
        (user) =>
          user.totalDepositsEur > 0 ||
          user.totalDepositsUsd > 0 ||
          user.totalDepositsGbp > 0
      ) // Solo usuarios que han hecho depósitos
      .sort((a, b) => b.totalDepositsEur - a.totalDepositsEur); // Ordenar por depósitos en EUR
  };

  // Totales diarios
  const [dailyTotalsByUser, setDailyTotalsByUser] = useState([]);

  // Calcular totales diarios
  const calculateDailyTotals = (date) => {
    const selectedDate = date.toISOString().split("T")[0];
    let totalDepositsEur = 0;
    let totalWithdrawalsEur = 0;
    let totalDepositsUsd = 0;
    let totalWithdrawalsUsd = 0;
    let totalDepositsGbp = 0;
    let totalWithdrawalsGbp = 0;
    const userTotalsMap = new Map();

    movements
      .filter((m) => m.mov_date === selectedDate)
      .forEach((m) => {
        if (!userTotalsMap.has(m.User.use_id)) {
          userTotalsMap.set(m.User.use_id, {
            user: m.User,
            depositsEur: 0,
            depositsUsd: 0,
            depositsGbp: 0,
            withdrawalsEur: 0,
            withdrawalsUsd: 0,
            withdrawalsGbp: 0,
          });
        }
        const userData = userTotalsMap.get(m.User.use_id);
        if (m.mov_type === "Deposito") {
          if (m.mov_currency === "EUR") {
            totalDepositsEur += m.mov_amount;
            userData.depositsEur += m.mov_amount;
          }
        } else if (m.mov_type === "Retiro") {
          if (m.mov_oldCurrency === "USD") {
            totalWithdrawalsUsd += m.mov_oldAmount;
            userData.withdrawalsUsd += m.mov_oldAmount;
          }
        }
        userTotalsMap.set(m.User.use_id, userData);
      });

    setDailyTotalsByUser(Array.from(userTotalsMap.values()));
    setDailyTotalDepositsEur(totalDepositsEur);
    setDailyTotalWithdrawalsEur(totalWithdrawalsEur);
    setDailyTotalDepositsUsd(totalDepositsUsd);
    setDailyTotalWithdrawalsUsd(totalWithdrawalsUsd);
    setDailyTotalDepositsGbp(totalDepositsGbp);
    setDailyTotalWithdrawalsGbp(totalWithdrawalsGbp);
  };

  // Estados para los totales diarios
  const [dailyTotalDepositsEur, setDailyTotalDepositsEur] = useState(0);
  const [dailyTotalWithdrawalsEur, setDailyTotalWithdrawalsEur] = useState(0);
  const [dailyTotalDepositsUsd, setDailyTotalDepositsUsd] = useState(0);
  const [dailyTotalWithdrawalsUsd, setDailyTotalWithdrawalsUsd] = useState(0);
  const [dailyTotalDepositsGbp, setDailyTotalDepositsGbp] = useState(0);
  const [dailyTotalWithdrawalsGbp, setDailyTotalWithdrawalsGbp] = useState(0);

  const openDailyModal = () => {
    calculateDailyTotals(dailyDate);
    setShowModalDepositsAndWithdrawals(true);
  };

  // Calcular totales
  const calcularTotales = () => {
    let totalDepositoEur = 0;
    let totalDepositoUsd = 0;
    let totalDepositoGbp = 0;

    // Totales de retiros en las monedas originales (EUR, USD, GBP)
    let totalRetiroOriginalEur = 0;
    let totalRetiroOriginalUsd = 0;
    let totalRetiroOriginalGbp = 0;

    // Totales de retiros equivalentes en las monedas nuevas (ARS, COP, CLP, etc.)
    let totalRetiroBolivares = 0;
    let totalRetiroArs = 0;
    let totalRetiroCop = 0;
    let totalRetiroClp = 0;
    let totalRetiroPen = 0;
    let totalRetiroEcu = 0;
    let totalRetiroPan = 0;
    let totalRetiroBrl = 0;
    let totalRetiroMex = 0;
    let totalRetiroUsd = 0;
    let totalRetiroEur = 0;

    movements
      .filter(
        (mov) =>
          mov.mov_date.slice(0, 10) === fechaFiltro && mov.mov_status === "V"
      )
      .forEach((mov) => {
        if (mov.mov_type === "Deposito") {
          // Calcular los depósitos según la moneda en el campo mov_currency
          if (mov.mov_currency === "EUR") {
            totalDepositoEur += mov.mov_amount;
          } else if (mov.mov_currency === "USD") {
            totalDepositoUsd += mov.mov_amount;
          } else if (mov.mov_currency === "GBP") {
            totalDepositoGbp += mov.mov_amount;
          }
        } else if (mov.mov_type === "Retiro") {
          // Calcular los retiros utilizando mov_oldCurrency (moneda original)
          if (mov.mov_oldCurrency === "EUR") {
            totalRetiroOriginalEur += mov.mov_oldAmount;
          } else if (mov.mov_oldCurrency === "USD") {
            totalRetiroOriginalUsd += mov.mov_oldAmount;
          } else if (mov.mov_oldCurrency === "GBP") {
            totalRetiroOriginalGbp += mov.mov_oldAmount;
          }

          // Calcular el total equivalente del retiro en la nueva moneda (mov_currency)
          if (mov.mov_currency === "" || mov.mov_currency === "Bs") {
            totalRetiroBolivares += mov.mov_amount;
          } else if (mov.mov_currency === "ARS") {
            totalRetiroArs += mov.mov_amount;
          } else if (mov.mov_currency === "COP") {
            totalRetiroCop += mov.mov_amount;
          } else if (mov.mov_currency === "CLP") {
            totalRetiroClp += mov.mov_amount;
          } else if (mov.mov_currency === "PEN") {
            totalRetiroPen += mov.mov_amount;
          } else if (mov.mov_currency === "USD-ECU") {
            totalRetiroEcu += mov.mov_amount;
          } else if (mov.mov_currency === "USD-PAN") {
            totalRetiroPan += mov.mov_amount;
          } else if (mov.mov_currency === "BRL") {
            totalRetiroBrl += mov.mov_amount;
          } else if (mov.mov_currency === "MEX") {
            totalRetiroMex += mov.mov_amount;
          } else if (mov.mov_currency === "USD") {
            totalRetiroUsd += mov.mov_amount;
          } else if (mov.mov_currency === "EUR") {
            totalRetiroEur += mov.mov_amount;
          }
        }
      });

    return {
      // Depósitos
      totalDepositoEur,
      totalDepositoUsd,
      totalDepositoGbp,

      // Retiros originales (antes de la conversión)
      totalRetiroOriginalEur,
      totalRetiroOriginalUsd,
      totalRetiroOriginalGbp,

      // Retiros equivalentes después de la conversión
      totalRetiroBolivares,
      totalRetiroArs,
      totalRetiroCop,
      totalRetiroClp,
      totalRetiroPen,
      totalRetiroEcu,
      totalRetiroPan,
      totalRetiroBrl,
      totalRetiroMex,
      totalRetiroUsd,
      totalRetiroEur,
    };
  };

  const {
    totalRetiroOriginalEur,
    totalRetiroOriginalUsd,
    totalRetiroOriginalGbp,
    totalDepositoEur,
    totalDepositoUsd,
    totalDepositoGbp,
    totalRetiroBolivares,
    totalRetiroArs,
    totalRetiroCop,
    totalRetiroClp,
    totalRetiroPen,
    totalRetiroEcu,
    totalRetiroPan,
    totalRetiroBrl,
    totalRetiroMex,
  } = calcularTotales();

  return (
    <div className="relation-dashboard">
      <h2 className="section-title">Relación de Recargas y Retiros</h2>

      {/* Filtro de Fechas */}
      <div className="date-filter">
        <label htmlFor="fecha">Filtrar por Fecha:</label>
        <input
          type="date"
          id="fecha"
          value={fechaFiltro}
          onChange={(e) => setFechaFiltro(e.target.value)}
        />
      </div>

      {/* Botones de Filtro */}
      <div className="filter-buttons">
        <button
          className={tipoMovimiento === "Deposito" ? "active" : ""}
          onClick={() => {
            setTipoMovimiento("Deposito");
            setFiltro("TODOS");
          }}
        >
          Depósito
        </button>
        <button
          className={tipoMovimiento === "Retiro" ? "active" : ""}
          onClick={() => {
            setTipoMovimiento("Retiro");
            setFiltro("TODOS");
          }}
        >
          Retiro
        </button>
        <button
          className={filtro === "EUR" ? "active" : ""}
          onClick={() => {
            setFiltro("EUR");
            setTipoMovimiento("Retiro");
          }}
        >
          Retiro de Euros
        </button>
        <button
          className={filtro === "USD" ? "active" : ""}
          onClick={() => {
            setFiltro("USD");
            setTipoMovimiento("Retiro");
          }}
        >
          Retiro de Dólares
        </button>
        <button
          className={filtro === "GBP" ? "active" : ""}
          onClick={() => {
            setFiltro("GBP");
            setTipoMovimiento("Retiro");
          }}
        >
          Retiro de Libras
        </button>
        <button
          className={filtro === "TODOS" ? "active" : ""}
          onClick={() => {
            setFiltro("TODOS");
            setTipoMovimiento("TODOS");
          }}
        >
          Ver Todo
        </button>
      </div>

      {/* Tabla */}
      <div className="transactions-section">
        <table className="transactions-table">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Tipo</th>
              <th>Monto</th>
              <th>Moneda Origen</th>
              <th>Moneda Destino</th>
              <th>Valor de la Tasa</th>
              <th>Tipo Retiro</th>
              <th>País</th>
              <th>Estado</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            {movements.length > 0 ? (
              movements
                .filter((mov) => {
                  const isMatchingType =
                    tipoMovimiento === "TODOS" ||
                    mov.mov_type === tipoMovimiento;
                  const isMatchingCurrency =
                    filtro === "TODOS" || mov.mov_oldCurrency === filtro;
                  return (
                    isMatchingType &&
                    isMatchingCurrency &&
                    mov.mov_date.slice(0, 10) === fechaFiltro &&
                    mov.mov_status === "V"
                  );
                })
                .map((movement, index) => (
                  <tr key={index}>
                    <td>
                      {movement.User.use_name} {movement.User.use_lastName}
                    </td>

                    <td>
                      {movement.mov_type === "Deposito" ? "Deposito" : "Retiro"}
                    </td>

                    <td
                      style={{
                        color:
                          movement.mov_type === "Deposito"
                            ? "#178f6b"
                            : "#c62828",
                        fontWeight: 600,
                      }}
                    >
                      {movement.mov_type === "Deposito"
                        ? `${movement.mov_currency} ${movement.mov_amount}`
                        : `(${movement.mov_oldCurrency} ${movement.mov_oldAmount}) ➔ ${movement.mov_currency} ${movement.mov_amount}`}
                    </td>

                    <td>{movement.mov_oldCurrency || "-"}</td>
                    <td>{movement.mov_currency}</td>

                    <td>{movement.mov_currencyPrice || "-"}</td>

                    <td>
                      {movement.mov_type === "Retiro"
                        ? movement.mov_typeOutflow === "efectivo"
                          ? "Efectivo"
                          : movement.mov_typeOutflow === "sendOption"
                          ? "Transferencia"
                          : "-"
                        : "-"}
                    </td>

                    <td>
                      {movement.AccountsBsUser ? (
                        <>
                          {movement.AccountsBsUser.accbsUser_country}{" "}
                          {flagMap[
                            movement.AccountsBsUser.accbsUser_country
                          ] && (
                            <img
                              src={
                                flagMap[
                                  movement.AccountsBsUser.accbsUser_country
                                ]
                              }
                              alt={movement.AccountsBsUser.accbsUser_country}
                              style={{ width: "20px", verticalAlign: "middle" }}
                            />
                          )}
                        </>
                      ) : movement.mov_typeOutflow === "efectivo" ? (
                        <>
                          Venezuela{" "}
                          <img
                            src={venezuelaFlag}
                            alt="Venezuela"
                            style={{ width: "20px", verticalAlign: "middle" }}
                          />
                        </>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td>
                      {movement.mov_status === "V"
                        ? "Verificado"
                        : movement.mov_status === "E"
                        ? "En espera"
                        : movement.mov_status === "R"
                        ? "Rechazado"
                        : "-"}
                    </td>

                    <td>{movement.mov_date}</td>
                  </tr>
                ))
            ) : (
              <tr>
                <td colSpan="10">No hay movimientos disponibles</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Sección de Totales */}
      <h3>Depósitos</h3>
      <div className="transactions-section compact">
        <table className="transactions-table">
          <thead>
            <tr>
              <th>€ Euros</th>
              <th>$ Dólares</th>
              <th>£ Libras</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>€ {totalDepositoEur.toFixed(2)}</td>
              <td>$ {totalDepositoUsd.toFixed(2)}</td>
              <td>£ {totalDepositoGbp.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>Retiros</h3>
      <div className="totals-grid">
  {[
    { label: "Retiros en Euros", symbol: "€", value: totalRetiroOriginalEur },
    { label: "Retiros en Dólares", symbol: "$", value: totalRetiroOriginalUsd },
    { label: "Retiros en Libras", symbol: "£", value: totalRetiroOriginalGbp },
    { label: "Bolívares", symbol: "Bs", value: totalRetiroBolivares },
    { label: "Pesos Argentinos", symbol: "ARS", value: totalRetiroArs },
    { label: "Pesos Colombianos", symbol: "COP", value: totalRetiroCop },
    { label: "Pesos Chilenos", symbol: "CLP", value: totalRetiroClp },
    { label: "Soles Peruanos", symbol: "PEN", value: totalRetiroPen },
    { label: "Dólares Ecuatorianos", symbol: "USD", value: totalRetiroEcu },
    { label: "Dólares Panameños", symbol: "USD", value: totalRetiroPan },
    { label: "Reales Brasileños", symbol: "BRL", value: totalRetiroBrl },
    { label: "Pesos Mexicanos", symbol: "MEX", value: totalRetiroMex }
  ].map((item) => (
    <div className="currency-card" key={item.label}>
      <h4>{item.label}</h4>
      <p>
        <strong>{item.symbol}</strong>{" "}
        {item.value.toLocaleString("es-ES", { minimumFractionDigits: 2 })}
      </p>
    </div>
  ))}
</div>

<div className="transactions-section referrals-section">
  <h3>Movimientos de Referidos</h3>

  {/* Selector de fecha y botón para ver todos */}
  <div className="referrals-filters">
    <label htmlFor="fechaFiltroReferrals">Filtrar por Fecha:</label>
    <input
      type="date"
      id="fechaFiltroReferrals"
      value={fechaFiltroReferrals}
      onChange={(e) => setFechaFiltroReferrals(e.target.value)}
    />
    <button
      className="button-action"
      onClick={() => setFechaFiltroReferrals("")} // vacía para ver todos
    >
      Ver Todos
    </button>
  </div>

  {loadingReferrals ? (
    <p>Cargando movimientos de referidos...</p>
  ) : errorReferrals ? (
    <p className="error-message">{errorReferrals.message || "Error al cargar los referidos"}</p>
  ) : referralMovements.length > 0 ? (
    <table className="transactions-table referrals-table">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Refirió</th>
          <th>Referido</th>
          <th>Monto Bono (€)</th>
        </tr>
      </thead>
      <tbody>
        {referralMovements
          .filter((rel) =>
            fechaFiltroReferrals
              ? rel.createdAt?.slice(0, 10) === fechaFiltroReferrals
              : true
          )
          .map((rel, index) => (
            <tr key={index}>
              <td>{rel.createdAt?.slice(0, 10) || "—"}</td>
              <td>
                {rel.referrer
                  ? `${rel.referrer.use_name} ${rel.referrer.use_lastName}`
                  : "—"}
              </td>
              <td>
                {rel.referred
                  ? `${rel.referred.use_name} ${rel.referred.use_lastName}`
                  : "—"}
              </td>
              <td>€ {rel.amount?.toFixed(2) || "—"}</td>
            </tr>
          ))}
      </tbody>
    </table>
  ) : (
    <p>No hay movimientos de referidos.</p>
  )}
</div>

 <div className="transactions-section">
      <h3>Canjes de Puntos</h3>

      {/* Filtro de fecha */}
      <div className="date-filter">
        <DatePicker
          selected={filterDate}
          onChange={(date) => {
            setFilterDate(date);
            setShowAll(false);
          }}
        />
        <button
          className="button-action"
          onClick={() => setShowAll(true)}
        >
          Ver todos
        </button>
      </div>

      {loadingRedemptions ? (
        <p>Cargando canjes de puntos...</p>
      ) : errorRedemptions ? (
        <p>Error: {errorRedemptions.message}</p>
      ) : filteredRedemptions.length > 0 ? (
        <table className="transactions-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Usuario</th>
              <th>Puntos Usados</th>
              <th>Monto Acreditado</th>
            </tr>
          </thead>
          <tbody>
            {filteredRedemptions.map((r) => (
              <tr key={r.pr_id}>
                <td>{r.pr_date.slice(0, 10)}</td>
                <td>{`${r.user.use_name} ${r.user.use_lastName}`}</td>
                <td>{r.pr_pointsUsed}</td>
                <td>€ {r.pr_amountCredited}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay canjes de puntos para la fecha seleccionada.</p>
      )}
    </div>
  






      {/* Botones */}
      <button className="button-action" onClick={() => setShowModal(true)}>
        Usuarios con saldo positivo
      </button>
      <button
        className="button-action"
        onClick={() => setShowDepositModal(true)}
      >
        Ranking de depósitos
      </button>
      <button className="button-action" onClick={openDailyModal}>
        Totales del día
      </button>

      {/* Usuarios con saldo positivo */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Usuarios con saldo positivo</h3>
            <button onClick={() => setShowModal(false)}>Cerrar</button>
            <table className="positive-balance-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Saldo USD</th>
                  <th>Saldo EUR</th>
                  <th>Saldo GBP</th>
                </tr>
              </thead>
              <tbody>
                {usersWithPositiveBalance.length > 0 ? (
                  usersWithPositiveBalance.map((user) => (
                    <tr key={user.use_id}>
                      <td>
                        {user.use_name} {user.use_lastName}
                      </td>
                      <td>${user.use_amountUsd.toFixed(2)}</td>
                      <td>€{user.use_amountEur.toFixed(2)}</td>
                      <td>£{user.use_amountGbp.toFixed(2)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No hay usuarios con saldo positivo</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showDepositModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Ranking Depósitos</h3>
            <button onClick={() => setShowDepositModal(false)}>Cerrar</button>

            {/* Filtros de Fecha */}
            <div className="date-filter">
              <label>Desde:</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
              <label>Hasta:</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
              />
            </div>

            <table className="table deposit-ranking-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Total Depósitos (EUR)</th>
                  <th>Total Depósitos (USD)</th>
                  <th>Total Depósitos (GBP)</th>
                </tr>
              </thead>
              <tbody>
                {getUserDepositRanking().map((user, index) => (
                  <tr key={index}>
                    <td>{`${user.use_name} ${user.use_lastName}`}</td>
                    <td>€{(user.totalDepositsEur || 0).toFixed(2)}</td>
                    <td>${(user.totalDepositsUsd || 0).toFixed(2)}</td>
                    <td>£{(user.totalDepositsGbp || 0).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showModalDepositsAndWithdrawals && (
        <div className="modal-overlay">
          <div className="deposits-withdrawals-modal">
            <div className="modal-content">
              <h3>Total de Depósitos y Retiros</h3>
              <button
                className="button close-button"
                onClick={() => setShowModalDepositsAndWithdrawals(false)}
              >
                X
              </button>

              {/* Calendario de filtro de rango */}
              <div className="date-filter">
                <label>Seleccionar Día:</label>
                <DatePicker
                  selected={dailyDate}
                  onChange={(date) => {
                    setDailyDate(date);
                    calculateDailyTotals(date);
                  }}
                />
              </div>

              {/* Totales por moneda */}
              <div className="totals-section">
                <div className="total-box">
                  <h5>Totales en EUR</h5>
                  <div className="amount deposits">
                    Depósitos: €{dailyTotalDepositsEur.toFixed(2)}
                  </div>
                  <div className="amount withdrawals">
                    Retiros: €{dailyTotalWithdrawalsEur.toFixed(2)}
                  </div>
                </div>
                <div className="total-box">
                  <h5>Totales en USD</h5>
                  <div className="amount deposits">
                    Depósitos: ${dailyTotalDepositsUsd.toFixed(2)}
                  </div>
                  <div className="amount withdrawals">
                    Retiros: ${dailyTotalWithdrawalsUsd.toFixed(2)}
                  </div>
                </div>
                <div className="total-box">
                  <h5>Totales en GBP</h5>
                  <div className="amount deposits">
                    Depósitos: £{dailyTotalDepositsGbp.toFixed(2)}
                  </div>
                  <div className="amount withdrawals">
                    Retiros: £{dailyTotalWithdrawalsGbp.toFixed(2)}
                  </div>
                </div>
              </div>

              {/* Tabla de desglose */}
              <h4>Depósitos y Retiros por Usuario y Moneda</h4>
              <table className="user-totals-table">
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Depósitos EUR</th>
                    <th>Depósitos USD</th>
                    <th>Depósitos GBP</th>
                    <th>Retiros EUR</th>
                    <th>Retiros USD</th>
                    <th>Retiros GBP</th>
                  </tr>
                </thead>
                <tbody>
                  {dailyTotalsByUser.length > 0 ? (
                    dailyTotalsByUser.map((entry, index) => (
                      <tr key={index}>
                        <td>{`${entry.user.use_name} ${entry.user.use_lastName}`}</td>
                        <td className="deposits">
                          €{entry.depositsEur.toFixed(2)}
                        </td>
                        <td className="deposits">
                          ${entry.depositsUsd.toFixed(2)}
                        </td>
                        <td className="deposits">
                          £{entry.depositsGbp.toFixed(2)}
                        </td>
                        <td className="withdrawals">
                          €{entry.withdrawalsEur.toFixed(2)}
                        </td>
                        <td className="withdrawals">
                          ${entry.withdrawalsUsd.toFixed(2)}
                        </td>
                        <td className="withdrawals">
                          £{entry.withdrawalsGbp.toFixed(2)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">
                        No hay depósitos o retiros para el día seleccionado
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      <NavBarAdm />
    </div>
  );
}

export { Relation };
